import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: calc(50% - 22px);\n  cursor: pointer;\n  width: 44px;\n  height: 44px;\n  border: 1px solid #EAE7E7;\n  border-radius: 99px;\n  background: url(\"", "\") no-repeat center center;\n\n  ", "\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import leftArrow from '../assets/icons/arrow-left.svg';
import rightArrow from '../assets/icons/arrow-right.svg';
import styled from '../utils/styling/styled-components';
import { Ink } from '../Ink';
export var Direction;

(function (Direction) {
  Direction[Direction["Left"] = 0] = "Left";
  Direction[Direction["Right"] = 1] = "Right";
})(Direction || (Direction = {}));

var left = function left(styles) {
  return function (props) {
    return props.direction === Direction.Left ? styles : null;
  };
};

var right = function right(styles) {
  return function (props) {
    return props.direction === Direction.Right ? styles : null;
  };
};

var Button = styled.button(_templateObject(), function (props) {
  return props.direction === Direction.Left ? leftArrow : rightArrow;
}, left("\n    left: 0;\n  "), right("\n    right: 0;\n  "));

var ArrowButton = function ArrowButton(props) {
  return /*#__PURE__*/React.createElement(Button, _extends({
    "aria-label": props.direction === Direction.Left ? 'Go Left' : 'Go Right'
  }, props), /*#__PURE__*/React.createElement(Ink, {
    opacity: 0.02
  }));
};

export { ArrowButton };